<script>
	import { onMount, createEventDispatcher } from 'svelte';
	import { fade } from 'svelte/transition';
    import { exportSummary } from '../grid/data-grid';
	import { save, refresh, trash, arrowRoundBack } from 'ionicons/icons/index.mjs';
	const dispatch = createEventDispatcher();
    export let modal;
    export let tooltips;
    export let templates;

	function sendMessage(message) {
		dispatch('message', message);
	}
    function close() {
		dispatch('message', {
            type: "modal",
            modal: null
		});
    }
</script>

<div class="modal modal-lg active">
    <div class="modal-overlay" on:click={close} aria-label="Close"></div>
    <div id="modal-container" class="modal-container">
        <div class="modal-header">
            <div class="tile tile-centered">
                <div class="tile-content">
                    <div class="tile-title">Templates</div>
                </div>
                <div class="tile-action">
                    {#if modal.back}
                        <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Back" on:click|stopPropagation={(e) => {
							e.currentTarget.blur();
							sendMessage({
								type: "modal",
								data: modal.back
							})
						}} aria-label="Back"><i class="svg svg-light">{@html arrowRoundBack.md}</i></button>
                    {/if}
                    <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Close" on:click={close} aria-label="Close"><i class="icon icon-cross mt-1"></i></button>
                </div>
            </div>
        </div>
        <div class="modal-body">
            {#if templates && templates.length > 0}
                {#each templates as template}
                  {#if modal.type == template.type}
                    <ul class="menu menu-nav" in:fade>
                        <div class="tile tile-centered">
                            <div class="tile-content">
                                <li class="menu-item">
                                    <button class="btn btn-link"
                                    on:click|stopPropagation={(e) => {
                                        e.currentTarget.blur();
                                        if (modal.export) {
                                           exportSummary(modal.columns, modal.rows, modal.title, template);
                                           close();
                                        }
                                        else {
                                            sendMessage({
                                                type: "modal",
                                                data: {
                                                    view: "summary",
                                                    template: template,
                                                    feature: modal.feature,
                                                    layer: modal.layer,
                                                    feature_id: modal.feature_id,
                                                    back: modal.back
                                                }
                                            })
                                        }
                                    }}>{template.name}</button>
                                </li>
                            </div>
                        </div>
                    </ul>
                    {/if}
                {/each}
            {/if}
        </div>
    </div>
</div>

<style>
	.modal.modal-lg .modal-overlay {
        background: rgba(247, 248, 249, 0.75);
    }
    .modal.modal-lg .modal-container {
        height: 100vh;
        height: calc(var(--vh, 1vh) * 100);
        padding: 0;
    }
    .modal.modal-lg .modal-header {
        background-color: #00ab5f;
        color: #fff;
        padding: 0.2rem 0.4rem;
    }
    .modal.modal-lg .modal-header .btn.btn-link {
        color: white;
    }
    .modal.modal-lg .modal-body {
        padding: 0;
        height: calc(100vh - 2.1rem);
    }
    .menu {
        padding: 0;
    }
    .menu .menu-item {
        padding: 0;
    }
	.menu .menu-item > button {
        border: 0;
        padding: 0.4rem 0.8rem;
	}
    ::-webkit-scrollbar {
		width: 6px;
		background-color: #f7f8f9;
	}
	::-webkit-scrollbar-thumb {
		background-color: rgba(122,129,132, 1);
    }
</style>